import { styled } from '@mui/material/styles'

export type ComponentProps = {
  checked?: boolean
}

export const Wrapper = styled('div') <ComponentProps>`
  display: flex;
  align-items: center;
  min-height: 70px;

  .container {
    display: flex;
    align-items: center;
    position: relative;
    padding-left: 32px;
    cursor: ${({ theme, disabled }) => disabled ? 'not-allowed' : 'pointer'};
    font-size: 22px;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
  }

  .container input {
    position: absolute;
    opacity: 0;
    cursor: pointer;
    height: 0;
    width: 0;
  }

    .container input:disabled ~ .checkmark {
      cursor: not-allowed;
    }

  .checkmark {
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    left: 0;
    height: 24px;
    width: 24px;
    background-color: transparent;
    color: ${({ theme }) => theme.colors.white};
    border: ${({ theme }) => `2px solid ${theme.colors.neutral.shades.shade600}`};
    border-radius: 4px;
  }

  .container input:disabled ~ .checkmark {
    border: ${({ theme }) => `2px solid ${theme.colors.neutral.shades.shade300}`};
  }

  .container input ~ .checkmark {
    background-color: ${({ theme, checked }) => checked ? theme.colors.blue.shades.shade600 : theme.colors.white};
  }

  .container input:hover ~ .checkmark {
    background-color: ${({ theme, checked }) => checked ? theme.colors.blue.shades.shade700 : theme.colors.white};
  }

  .container input:disabled ~ .checkmark {
    background-color: ${({ theme }) => theme.colors.neutral.shades.shade300};
  }
`

export const Checkbox = styled('input')`
  position: absolute;
  opacity: 0;
  cursor: pointer;
  height: 0;
  width: 0;
`

export const CheckMark = styled('span')`
  display: flex;
  justify-content: center;
  align-items: center;
  color: ${({ theme }) => theme.colors.white};
`

export const Label = styled('label')`
  input[type='checkbox']:focus {
    outline: none;
    box-shadow: none;
  }

  input[type='checkbox']:focus + .checkmark {
    outline: ${({ theme }) => `2px solid ${theme.colors.neutral.shades.shade300}`}
  }
`;
